import { render } from "./SurveyMain.vue?vue&type=template&id=0351adbb&scoped=true"
import script from "./SurveyMain.vue?vue&type=script&lang=js"
export * from "./SurveyMain.vue?vue&type=script&lang=js"

import "./SurveyMain.vue?vue&type=style&index=0&id=0351adbb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0351adbb"]])

export default __exports__